import React from 'react';

import LoadingButton from '@mui/lab/LoadingButton';
import {
  Box,
  Typography,
  Button,
  IconButton,
  Select,
  MenuItem,
} from '@mui/material';
import SnackbarUtils from 'src/common/utils/SnackbarUtilsConfigurator';

import { useOverwriteSubscriptionMutation } from '../../../../common/apis/AdminApi';
import { ReactComponent as CancelIconBlue } from '../../../../common/assets/icons/cancel_icon_blue.svg';
import { User } from '../../../../common/types/User';
import { SubscriptionType } from '../../../../florence/types/SubscriptionType';

type Props = {
  user: User;
  onClose: () => void;
};

const OverwriteSubscriptionPopup: React.FC<Props> = ({ onClose, user }) => {
  const [value, setValue] = React.useState(
    !user.overwriteSubscription ? 'none' : user.overwriteSubscription
  );
  const [overwriteSubscripton, { isLoading }] =
    useOverwriteSubscriptionMutation();

  const submit = async () => {
    if (isDisabled()) return;

    let newSub: SubscriptionType = null;

    if (value === 'none') newSub = null;
    else if (value === 'trial') newSub = 'trial';
    else if (value === 'mobile') newSub = 'mobile';
    else if (value === 'desktop') newSub = 'desktop';

    overwriteSubscripton({
      id: user.id.toString(),
      subscription: newSub,
    })
      .unwrap()
      .then((res) => {
        SnackbarUtils.success(res.message);
        onClose();
      });
  };

  const isDisabled = () =>
    (!user.overwriteSubscription && value === 'none') ||
    user.overwriteSubscription === value;

  return (
    <Box
      sx={{
        maxWidth: '456px',
        minHeight: '274px',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        flex: 1,
        borderRadius: '15px',
        padding: '40px',
        flexDirection: 'column',
      }}
    >
      <Box className='row' sx={{ alignItems: 'center' }}>
        <IconButton
          disabled={isLoading}
          onClick={onClose}
          sx={{ alignSelf: 'flex-start', justifySelf: 'right' }}
        >
          <CancelIconBlue />
        </IconButton>
        <Typography
          sx={{
            alignSelf: 'center',
            whiteSpace: 'break-spaces',
            textAlign: 'center',
            mb: '24px',
            ml: 'auto',
            mr: 'auto',
          }}
          color='text.primary'
          variant='h5'
        >
          Subscription
        </Typography>
        <Box sx={{ mr: 'auto' }} />
      </Box>
      <Box>
        <Select
          value={value}
          onChange={(e) => setValue(e.target.value)}
          fullWidth
        >
          <MenuItem value={'none'}>None</MenuItem>
          <MenuItem value={'trial'}>Trial</MenuItem>
          <MenuItem value={'mobile'}>Mobile</MenuItem>
          <MenuItem value={'desktop'}>Desktop</MenuItem>
        </Select>
      </Box>
      <Box
        sx={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          alignSelf: 'center',
          display: 'flex',
          marginTop: '20px',
        }}
      >
        <Button
          onClick={onClose}
          disabled={isLoading}
          disableElevation
          color='appGray2'
          variant='contained'
          sx={{
            borderRadius: '50px',
            width: '180px',
            height: '60px',
            marginRight: '15px',
          }}
        >
          <Typography color='white'>Cancel</Typography>
        </Button>
        <LoadingButton
          disabled={isDisabled()}
          onClick={submit}
          loading={isLoading}
          disableElevation
          color='primary'
          variant='contained'
          sx={{
            borderRadius: '50px',
            width: '180px',
            height: '60px',
          }}
        >
          <Typography color='white'>Ok</Typography>
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default OverwriteSubscriptionPopup;
